export default __webpack_public_path__ + "static/member-plant-2-2-2b72ad8b96d54bde228ae302c5a5b0af.png";